export const config = {
  title: "D.C. Custom Painting | Residential & Commercial Painting in Tonawanda, NY",
  meta: {
    description:
      "D.C. Custom Painting delivers top-notch interior and exterior painting services for homes and businesses across Tonawanda, NY and surrounding areas.",
    keywords: [
      "Tonawanda NY painting services",
      "D.C. Custom Painting",
      "residential painting Tonawanda",
      "commercial painting NY",
      "interior and exterior painting"
    ],
    author: "D.C. Custom Painting",
    canonicalUrl: "https://www.dccustompainting.com/",
  },
  sections: {
    header: {
      businessName: "D.C. Custom Painting",
    },
    sectionB: {
      heroTitle: "D.C. Custom Painting",
      heroSubtitle: "Expert Painting for Homes & Businesses in Tonawanda, NY",
      learnAboutText: "Get a Free Estimate",
      phoneNumber: "7164822741",
      phoneLabel: "(716) 482-2741",
      heroBackgroundImage:
      "https://media.istockphoto.com/id/1461683093/photo/man-painting-wall-with-light-blue-dye-indoors-back-view.jpg?s=612x612&w=0&k=20&c=TDg87xVDJh-VA4zVClGlMnqpdqTh2QcZ--raihCv9XU=",
      cardData: [
        {
          title: "Residential Painting",
          description: "Refresh your home with expert interior and exterior paint services.",
        },
        {
          title: "Commercial Painting",
          description: "Elevate your business space with professional painting solutions.",
        },
        {
          title: "Custom Finishes",
          description: "High-quality craftsmanship tailored to your vision and style.",
        },
      ],
      description:
        "With over 25 years of experience, D.C. Custom Painting is your trusted painting contractor for residential and commercial projects in Tonawanda, NY.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We bring precision and excellence to every brushstroke, transforming your space with lasting results.",
      cards: [
        {
          title: "Interior Painting",
          description: "Crisp, clean, and consistent results that brighten every room.",
          imageSrc: "https://media.istockphoto.com/id/2190057704/photo/man-painting-living-room-wall-during-apartment-renovation.jpg?s=612x612&w=0&k=20&c=YdjDxlzP_PRNjX_yERTALgepZALghon-9H4PUF52ygw=",
          imageAlt: "Interior Painting",
        },
        {
          title: "Exterior Painting",
          description: "Boost curb appeal and protect your property with weather-resistant finishes.",
          imageSrc: "https://media.istockphoto.com/id/176882062/photo/painter-working-at-roofline.jpg?s=612x612&w=0&k=20&c=ThyFPXfjLyxM4yBEENMVQoXA9ofKg-sDCBs10RIdVos=",
          imageAlt: "Exterior Painting",
        },
        {
          title: "Custom Projects",
          description: "We bring your painting ideas to life—no job is too small or too big.",
          imageSrc: "https://media.istockphoto.com/id/2161507261/photo/a-professional-house-painters-painting-an-apartment.jpg?s=612x612&w=0&k=20&c=23syAvxJUCVG_vug99OBXq5ew2-R5H95FCgXgbJlxhU=",
          imageAlt: "Custom Painting",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "25+ Years of Experience",
        "Locally Owned & Operated",
        "Attention to Detail",
        "Licensed & Insured",
        "Free Estimates",
      ],
    },
    sectionD: {
      aboutTitle: "About D.C. Custom Painting",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2221468674/photo/painting-an-exterior-wall-with-a-white-paint-roller-brush-outdoor-home-renovation-concept.jpg?s=612x612&w=0&k=20&c=jlB1fuHslW8e5ZvC3tDOjDBdl6YJapHLntHR-ViPhTA=",
        alt: "D.C. Custom Painting Team",
      },
      aboutText: [
        "D.C. Custom Painting is a trusted name in Tonawanda, NY for high-quality painting services tailored to your needs.",
        "We work closely with homeowners and business owners to deliver lasting beauty and protection with every paint job.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "D.C. Custom Painting Logo",
      businessName: "D.C. Custom Painting",
      contact: {
        phone: "7164822741",
        phoneLabel: "(716) 482-2741",
        email: "abbinanti31@gmail.com",
        website: "https://www.dccustompainting.com/",
        address: "Tonawanda, NY 14120, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Tonawanda, NY 14120, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2912.150003186336!2d-78.87836958453374!3d43.02031267914737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d373b1c6cc89d1%3A0xc0702f2073f2c1b1!2sTonawanda%2C%20NY%2014120%2C%20USA!5e0!3m2!1sen!2sus!4v1692794585000!5m2!1sen!2sus",
    },
  },
};

export default config;
